import { deepClone } from './dataHelpers';

export const applyDocumentFieldToAllPartidas = (
  editableData,
  declarationIndex,
  sourcePartidaIndex,
  documentIndex,
  field,
  value = undefined
) => {
  // Early validation with single return
  if (!Array.isArray(editableData)) return editableData;
  
  const declaration = editableData[declarationIndex];
  const sourcePartida = declaration?.partidas?.[sourcePartidaIndex];
  if (!Array.isArray(declaration?.partidas) || !sourcePartida) return editableData;

  // Get value to apply (prefer provided value, fallback to source document)
  const valueToApply = value ?? sourcePartida.documentos?.[documentIndex]?.[field];
  if (valueToApply === undefined) return editableData;

  // Deep clone and apply to all documents across all partidas
  const updatedData = deepClone(editableData);
  const updatedDeclaration = updatedData[declarationIndex];

  updatedDeclaration.partidas.forEach((partida) => {
    if (Array.isArray(partida.documentos)) {
      partida.documentos.forEach((doc) => {
        if (doc && typeof doc === 'object') {
          doc[field] = valueToApply;
        }
      });
    }
  });

  return updatedData;
};

